import styled from "@emotion/styled";

import type * as auth from "@skilitics/auth-client";
import { ModalDialog } from "@skilitics/designer-ui-components";
import { useFormatMessage } from "@skilitics/localization";

import { PendingButtons } from "./PendingButtons.tsx";

export interface ConfirmRemoveMemberDialogProps {
  member: auth.WorkspaceMember;
  confirm: () => Promise<void>;
  close: () => void;
}

export const ConfirmRemoveMemberDialog = ({ member, confirm, close }: ConfirmRemoveMemberDialogProps) => {
  const formatMessage = useFormatMessage(formatStrings);

  return (
    <ModalDialog
      open
      header={formatMessage("title")}
      buttons={
        <PendingButtons
          confirmLabel={formatMessage("confirmLabel")}
          cancelLabel={formatMessage("cancelLabel")}
          confirm={confirm}
          close={close}
        />
      }
      onClose={close}
    >
      <Content>
        <p>
          <strong>Removing {member.email} will have the following effects:</strong>
        </p>
        <ul>
          <li>They&apos;ll lose access to this workspace.</li>
          <li>They&apos;ll no longer have access to any content they&apos;ve created.</li>
          <li>The change will take effect the next time they log in.</li>
        </ul>
        <p>
          <strong>Are you sure you want to remove their access?</strong>
        </p>
      </Content>
    </ModalDialog>
  );
};

const Content = styled.div`
  font-size: 14px;
  line-height: 1.5;
  padding: 8px;

  p {
    margin: 0;
  }
`;

const formatStrings = {
  title: {
    en: "Remove Workspace Member?",
  },
  confirmLabel: {
    en: "Yes, remove member",
  },
  cancelLabel: {
    en: "No, cancel",
  },
};
